<template>
  <div class="feelgrid-puredata">
    <template v-if="available_devices.length">
      <header>
        <h2 class="title">{{ views[view] }}</h2>
        <ButtonSwitch v-model="view" :options=views classname="lg" />
      </header>
      <div
        :is="viewcomponents[view]"
        :grid=grid
        :devices=devices
        :available_devices=available_devices
        :id=id
        class="puredata-view"
      />
    </template>
    <Loading v-else-if="!devices" />
    <Panel class="user-info" v-else>{{ 'feelgrid:puredata.no_devices' | trans }}</Panel>
  </div>
</template>

<script>
  import ButtonSwitch from '@/helpers/components/interact/ButtonSwitch'
  import GraphView from './GraphView'
  import DeviceView from './DeviceView'
  import SensorView from './SensorView'
  import base from '../../mixins'

  export default {
    name: 'Module',
    mixins: [base],
    components: {ButtonSwitch, GraphView, DeviceView, SensorView},
    data() {return {
      view: 'graph',
      viewcomponents: {
        graph: GraphView,
        device: DeviceView,
        sensor: SensorView,
      },
    }},
    computed: {
      //real installed devices only
      available_devices () {
        if (!this.devices) {
          return [];
        }
        return this.devices
          .filter(d => {
            if (['pending', 'processing'].includes(d.status)) {
              return false;
            }
            if (d.type !== 'device') {
              return false;
            }
            return true;
          })
        ;
      },
      views () {
        return _.mapValues(
          this.viewcomponents,
          (v, k) => this.$t('feelgrid:puredata.views.' + k)
        );
      },
    },
  }
</script>

<style lang="scss">
  @import '../../scss/variables';
  
  .feelgrid-puredata {
    > header {
      padding: $panel-margin $panel-margin 0;
      @include clearfix;
      > * {
        float: left;
      }
      > :last-child {
        float: right;
      }
      .button-switch .btn {
        text-transform: uppercase;
      }
    }
    .scrollable-table {
      overflow-x: auto;
    }
    div.data-table {
      margin-top: 20px;
      div.list-holder table.itemstable {
        th.type, td.type {
          @include table-col-bg;
        }
        td {
          font-size: 16px !important;
        }
        td.type {
          min-width: 190px;
        }
        th, td {
          white-space: nowrap;
        }
        th.time {
          border-right: solid white 2px;
        }
        td.time {
          border-right: solid #F1F1F3 2px;
          padding-left: 10px;
          padding-right: 25px;
        }
        td.time + td {
          min-width: #{190px + 15px};
        }
        th.time + th, td.time + td {
          @include table-col-bg(15px);
        }
        .padder {
          width: 100%;
        }
      }
    }
    nav.pages.pagination {
      margin-top: 10px;
    }
    .puredata-view {
      .panel > header {
        padding-bottom: 10px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/apps/feelgrid/modules/pureData/Module.vue